module.exports = __webpack_public_path__ + "img/5.54511baf.png";